const cache = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_CACHE_ITEM':
      return {
        ...state,
        [action.name]: {
          data: action.value,
          ets: action.ets,
        },
      };
    case 'REMOVE_CACHE_ITEM':
      const removedcache = { ...state };
      delete removedcache[action.name];
      return removedcache;
    case 'DROP_CACHE':
      return {};
    default:
      return state;
  }
};

export default cache;
